import React from 'react';

import { AppRoutePages } from '@constants/routes';
import AuthPage from './AuthPage';

export default [{ path: AppRoutePages.Home, component: <AuthPage /> }];
